// styles/OnboardingPage.styles.js
const OnboardingStyles = {
    rootBox: {
      padding: '40px',
      maxWidth: '600px',
      margin: 'auto',
    },
    paper: {
      padding: '30px',
    },
    header: {
      marginBottom: '16px',
    },
    textField: {
      marginBottom: '24px',
    },
    disclosureText: {
      marginBottom: '16px',
      marginTop: '32px',
    },
    disclosurePaper: {
      padding: '20px',
      marginBottom: '24px',
      backgroundColor: '#f8f8f8',
      width: '100%',
      maxHeight: '200px',
      borderRadius: '4px',
    },
    canvas: {
      display: 'none',
      width: '320px',
      height: '240px',
    },
    errorText: {
      marginBottom: '16px',
    },
    submitButton: {
      marginTop: '24px',
    },
  };

  
  export default OnboardingStyles;
  